import React from "react";
import { AlertTriangle, Download } from "lucide-react";

const downloadCodesFile = (recoveryCodes) => {
  const txt = [
    "Kiwami Studios & Co — 2FA recovery codes",
    "Generated: " + new Date().toISOString(),
    "Each code can be used only once.",
    "",
    ...recoveryCodes,
  ].join("\n");
  const blob = new Blob([txt], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "kiwami-2fa-recovery-codes.txt";
  a.click();
  URL.revokeObjectURL(url);
};

/**
 * Shown once, right after 2FA is enabled, so the admin can save the
 * 8 one-time recovery codes that unlock the account if the phone is lost.
 */
const RecoveryCodesPanel = ({ recoveryCodes, lang, onDone }) => (
  <div className="space-y-4" data-testid="2fa-recovery-codes">
    <div className="flex items-start gap-3 p-4 border-l-2 border-[#C5A059] bg-[#C5A059]/5">
      <AlertTriangle
        className="w-5 h-5 text-[#C5A059] flex-shrink-0 mt-0.5"
        strokeWidth={1.5}
      />
      <div>
        <p className="font-serif-display text-xl text-[#F2EBE5]">
          {lang === "fr"
            ? "Conservez ces codes maintenant"
            : "Save these codes now"}
        </p>
        <p className="text-xs text-[#A19E9C] mt-1">
          {lang === "fr"
            ? "Ces 8 codes permettent de vous reconnecter si vous perdez votre téléphone. Chaque code n'est utilisable qu'une fois. Ils ne seront PAS affichés à nouveau."
            : "These 8 codes let you log in if you lose your phone. Each code works only once. They will NOT be shown again."}
        </p>
      </div>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
      {recoveryCodes.map((code, i) => (
        <code
          key={code}
          data-testid={`recovery-code-${i}`}
          className="font-mono text-sm text-[#F2EBE5] bg-[#050505] px-3 py-2 border border-[#F2EBE5]/10 select-all text-center"
        >
          {code}
        </code>
      ))}
    </div>
    <div className="flex items-center gap-4 pt-2">
      <button
        type="button"
        onClick={() => downloadCodesFile(recoveryCodes)}
        data-testid="2fa-download-codes"
        className="kw-btn-primary"
      >
        <Download className="w-4 h-4" strokeWidth={1.5} />
        {lang === "fr" ? "Télécharger (.txt)" : "Download (.txt)"}
      </button>
      <button
        type="button"
        onClick={onDone}
        data-testid="2fa-codes-done"
        className="kw-btn-ghost"
      >
        {lang === "fr" ? "J'ai sauvegardé" : "I've saved them"}
      </button>
    </div>
  </div>
);

export default RecoveryCodesPanel;
